import { render, staticRenderFns } from "./JoaOvertimeDetailList.vue?vue&type=template&id=2f47c2a4&scoped=true&"
import script from "./JoaOvertimeDetailList.vue?vue&type=script&lang=js&"
export * from "./JoaOvertimeDetailList.vue?vue&type=script&lang=js&"
import style0 from "./JoaOvertimeDetailList.vue?vue&type=style&index=0&id=2f47c2a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47c2a4",
  null
  
)

export default component.exports